module.exports = __webpack_public_path__ + "img/opal1.61bc16e2.png";